"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundingClientRectObserver = void 0;
var observeBounds_1 = require("./observeBounds");
/**
 * Class representing an observer that can be used to monitor changes in the bounding client rect of multiple elements.
 */
var BoundingClientRectObserver = /** @class */ (function () {
    function BoundingClientRectObserver(callback) {
        this._handles = new Map();
        this._callback = callback;
    }
    /**
     * Start observing changes in the bounding client rect of the given element.
     *
     * @param element - the element to observe
     */
    BoundingClientRectObserver.prototype.observe = function (element) {
        if (this._isObserved(element)) {
            return;
        }
        this._startObserving(element);
    };
    /**
     * Stop observing all elements
     */
    BoundingClientRectObserver.prototype.disconnect = function () {
        this._handles.forEach(function (handle) {
            handle.cancel();
        });
        this._handles.clear();
    };
    BoundingClientRectObserver.prototype._startObserving = function (element) {
        var _this = this;
        var newHandle = (0, observeBounds_1.observeBounds)(element, function (args) {
            // Although the interface allows emitting multiple entries at once (to mimic similar DOM interfaces),
            // currently it's easiest to emit only one entry at the time
            _this._callback([{
                    target: element,
                    previousBounds: args.previousBounds,
                    newBounds: args.newBounds,
                }], _this);
        });
        this._handles.set(element, newHandle);
    };
    BoundingClientRectObserver.prototype._isObserved = function (element) {
        return this._handles.has(element);
    };
    return BoundingClientRectObserver;
}());
exports.BoundingClientRectObserver = BoundingClientRectObserver;
//# sourceMappingURL=index.js.map